<template>
    <v-flex v-if="pillItem" class="filter-pill">
        <span class="filter-pill__close">
            <v-icon @click="close" color="black" size="18"
                    :data-qe-id="`community-directory_filer-pill_${filterIndex}_remove_btn`">close</v-icon></span>
        <span class="filter-pill__name" :data-qe-id="`community-directory_filer-pill_${filterIndex}_label`">{{pillLabel}}</span>
    </v-flex>
</template>
<script>

    export default {
        name: 'CommunityFilterPill',
        props: {
            pillItem: {
                type: Object,
                required: true,
            },
            filterIndex: {
                type: Number,
                required: true,
            },
            handleClose: {
                type: Function,
                required: true,
            },
        },
        methods: {
            close() {
                this.handleClose(this.pillItem);
            },
        },
        computed: {
            pillLabel() {
                return this.pillItem.label;
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';

    .filter-pill {
        border: 1px solid $ypo-tile-border;
        -webkit-border-radius: 16px;
        -moz-border-radius: 16px;
        border-radius: 16px;
        background-color: $white;
        flex: 0 1 auto !important;
        padding: 5px 10px;

        &__close {
            color: $black;
            position: relative;
            margin-top: -2px;
        }

        &__name {
            padding-left: 5px;
            color: $ypo-cta;
        }
    }

</style>
